var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeterWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2059 14.479C28.263 14.9612 28.2948 15.4528 28.2948 15.9524C28.2948 22.7294 22.7944 28.2248 16.0077 28.2248C11.0662 28.2248 6.80745 25.3113 4.85591 21.1101L6.82174 20.122C8.40962 23.6064 11.9252 26.0282 16.0077 26.0282C21.578 26.0282 26.0956 21.5177 26.0956 15.9524C26.0956 15.8493 26.094 15.7462 26.0908 15.6431L28.2059 14.479ZM16.0077 3.68C21.1826 3.68 25.6113 6.87579 27.4215 11.4006L25.3191 12.0699C23.7979 8.4332 20.2013 5.87661 16.0077 5.87661C10.4374 5.87661 5.91983 10.3871 5.91983 15.9524C5.91983 16.0206 5.92139 16.0904 5.92298 16.1586L3.86508 17.8397C3.76981 17.2244 3.72058 16.5947 3.72058 15.9524C3.72217 9.17389 9.22264 3.68 16.0077 3.68Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32007 20.8595L14.3372 11.0422L13.8387 15.1245L20.8524 11.1548L20.4967 15.0309L29.6969 12.1048L17.2193 18.969L18.1514 15.0627L10.9423 19.283L11.4187 16.2871L2.32007 20.8595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterWhite);
export default __webpack_public_path__ + "static/media/meter-white.5986137244f17950de5698efa4e48e43.svg";
export { ForwardRef as ReactComponent };